module.exports = __webpack_public_path__ + "static/media/vnr.01e40c7c.jpg";